module.exports = __webpack_public_path__ + "assets/img/img9.d45ef63f.png";